import React from "react";
// import "../../../Style/Footer.scss";
export default function Footer() {
  return (
    <div className="main-footer">
      <div class="footer-content">
        <p>&copy;2024 Stone Core. All rights reserved.</p>
      </div>
    </div>
  );
}
